<template>
  <CContainer class="pt-5 mb-5" fluid>
    <CRow>
      <CCol class="col-12 col-md-3 col-lg-4 col-xl-5">
        <h3 class="pl-3 mb-0 pb-0">Dashboard</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-home" />
            Dashboard
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
      <CCol class="col-2 pt-4 text-right">
        <span>Periode:</span>
      </CCol>
      <CCol class="col-10 col-md-7 col-lg-6 col-xl-5 pt-3">
        <b-input-group>
          <b-form-datepicker
            v-model="periodFrom" 
            :max="maxPeriodFrom"
            id="form-valid-start"
            placeholder="DD/MM/YYYY"
            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
            locale="id"
            :disabled="!cards.isLoaded"
            @context="onContextDateFrom"
            @input="onDateRangeSelect"
          ></b-form-datepicker>
          <b-input-group-append>
            <b-input-group-text>
              ~
            </b-input-group-text>
          </b-input-group-append>
          <b-form-datepicker
            v-model="periodTo" 
            :min="minPeriod"
            :max="maxPeriod"
            placeholder="DD/MM/YYYY"
            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
            locale="id"
            :disabled="!cards.isLoaded"
            @context="onContextDateTo"
            @input="onDateRangeSelect"
          ></b-form-datepicker>
        </b-input-group>
      </CCol>
      <CCol class="p-2" sm="6" lg="4" xl="3" v-for="item in Object.entries(cards.items)" :key="item.text">
        <CCard class="custom-card">
          <CCardBody v-if="cards.isLoaded">
            <img class="float-right" :src="require('@/assets/icons/' + item[1].img)"/>
            <CCardTitle class="custom-card-title">{{ $helper.showData(item[1].value, "number") }}</CCardTitle>
            <CCardSubtitle class="text-muted custom-card-subtitle">{{ item[1].text }}</CCardSubtitle>
          </CCardBody>
          <CCardBody v-else>
            <Skeleton class="float-right" type="circle" :width="40" :height="40" animation="fade"/>
            <CCardTitle><Skeleton type="rect" :width="100" :height="30" animation="fade"/></CCardTitle>
            <CCardSubtitle class="mb-2"><Skeleton type="rect" :width="150" :height="20" animation="fade"/></CCardSubtitle>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow v-if="$helper.isRole($availRoles['Cabang']) || $helper.isRole($availRoles['HO']) || $helper.isRole($availRoles['FIMS'])">
      <CCol>
        <CCard class="custom-card">
          <CCardHeader class="card-header">
            <h5>Jumlah Kontrak Fiducia per Notaris</h5>
          </CCardHeader>
          <CCardBody class="p-0">
            <b-table striped hover show-empty
              responsive="xl"
              :items="contractPerNotaryTable.items"
              :fields="contractPerNotaryTable.fields"
              :busy="!contractPerNotaryTable.isLoaded"
              no-local-sorting no-sort-reset
              @sort-changed="onSortChanged"
            >
              <template #cell(notaryCode)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(notaryName)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(officeName)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(contractStatus)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(contractCount)="row">
                {{ $helper.showData(row.value, "number") }}
              </template>
              <template slot="empty">
                <div v-if="!contractPerNotaryTable.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div>
              </template>
            </b-table>
            <CCardFooter>
              <PageSizer :totalRows="contractPerNotaryTable.totalRows" :page="contractPerNotaryTable.currentPage" :options="tablePageOptions" @limit-change="onLimitChange" @page-change="onPageChange" />
            </CCardFooter>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow v-if="$helper.isRole($availRoles['Cabang']) || $helper.isRole($availRoles['HO']) || $helper.isRole($availRoles['FIMS'])">
      <CCol>
        <CCard class="custom-card">
          <CCardHeader class="card-header">
            <h5>Jumlah Kontrak Roya per Notaris</h5>
          </CCardHeader>
          <CCardBody class="p-0">
            <b-table striped hover show-empty
              responsive="xl"
              :items="contractPerNotaryTable2.items"
              :fields="contractPerNotaryTable2.fields"
              :busy="!contractPerNotaryTable2.isLoaded"
              no-local-sorting no-sort-reset
              @sort-changed="onSortChanged2"
            >
              <template #cell(notaryCode)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(notaryName)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(officeName)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(contractStatus)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(contractCount)="row">
                {{ $helper.showData(row.value, "number") }}
              </template>
              <template slot="empty">
                <div v-if="!contractPerNotaryTable2.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div>
              </template>
            </b-table>
            <CCardFooter>
              <PageSizer :totalRows="contractPerNotaryTable2.totalRows" :page="contractPerNotaryTable2.currentPage" :options="tablePageOptions" @limit-change="onLimitChange" @page-change="onPageChange2" />
            </CCardFooter>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <template v-if="$helper.isRole($availRoles['Notaris'])">
      <CRow>
        <CCol>
          <CCard class="custom-card">
            <CCardHeader class="card-header">
              <h5>Kontrak Fiducia Mendekati Due Date</h5>
            </CCardHeader>
            <CCardBody class="p-0">
              <b-table striped hover show-empty
                responsive="xl"
                :items="contractDueTable.items"
                :fields="contractDueTable.fields"
                :busy="!contractDueTable.isLoaded"
                no-local-sorting no-sort-reset
              >
                <template #cell(contractNo)="row">
                  {{ $helper.showData(row.value, "string") }}
                </template>
                <template #cell(contractStatus)="row">
                  {{ $helper.showData(row.value, "string") }}
                </template>
                <template #cell(contractType)="row">
                  {{ $helper.showData(row.value, "string") }}
                </template>
                <template #cell(customerName)="row">
                  {{ $helper.showData(row.value, "string") }}
                </template>
                <template #cell(documentStatus)="row">
                  {{ $helper.showData(row.value, "string") }}
                </template>
                <template slot="empty">
                  <div v-if="!contractDueTable.isLoaded" class="text-center">
                    <b-spinner label="Fetching Data..."></b-spinner>
                  </div> 
                  <div v-else class="text-center">
                    Tidak ada data
                  </div> 
                </template>
              </b-table>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <CRow>
        <CCol>
          <CCard class="custom-card">
            <CCardHeader class="card-header">
              <h5>Kontrak Roya Mendekati Due Date</h5>
            </CCardHeader>
            <CCardBody class="p-0">
              <b-table striped hover show-empty
                responsive="xl"
                :items="contractDueTable2.items"
                :fields="contractDueTable2.fields"
                :busy="!contractDueTable2.isLoaded"
                no-local-sorting no-sort-reset
              >
                <template #cell(contractNo)="row">
                  {{ $helper.showData(row.value, "string") }}
                </template>
                <template #cell(contractStatus)="row">
                  {{ $helper.showData(row.value, "string") }}
                </template>
                <template #cell(contractType)="row">
                  {{ $helper.showData(row.value, "string") }}
                </template>
                <template #cell(customerName)="row">
                  {{ $helper.showData(row.value, "string") }}
                </template>
                <template #cell(documentStatus)="row">
                  {{ $helper.showData(row.value, "string") }}
                </template>
                <template slot="empty">
                  <div v-if="!contractDueTable2.isLoaded" class="text-center">
                    <b-spinner label="Fetching Data..."></b-spinner>
                  </div> 
                  <div v-else class="text-center">
                    Tidak ada data
                  </div> 
                </template>
              </b-table>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <CRow>
        <CCol>
          <CCard class="custom-card">
            <CCardHeader class="card-header">
              <h5>Invoice Mendekati Due Date</h5>
            </CCardHeader>
            <CCardBody class="p-0">
              <b-table striped hover show-empty
                responsive="xl"
                :items="invoiceDueTable.items"
                :fields="invoiceDueTable.fields"
                :busy="!invoiceDueTable.isLoaded"
                no-local-sorting no-sort-reset
              >
                <template #cell(invoiceNo)="row">
                  {{ $helper.showData(row.value, "string") }}
                </template>
                <template #cell(businessUnit)="row">
                  {{ $helper.showData(row.value, "string") }}
                </template>
                <template #cell(applicationDate)="row">
                  {{ $helper.showData(row.value, "shortDate") }}
                </template>
                <template #cell(contractType)="row">
                  {{ $helper.showData(row.value, "string") }}
                </template>
                <template #cell(totalPayment)="row">
                  {{ $helper.showData(row.value, "number") }}
                </template>
                <template slot="empty">
                  <div v-if="!invoiceDueTable.isLoaded" class="text-center">
                    <b-spinner label="Fetching Data..."></b-spinner>
                  </div> 
                  <div v-else class="text-center">
                    Tidak ada data
                  </div> 
                </template>
              </b-table>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </template>
  </CContainer>
</template>


<script>
export default {
  name: 'Dashboard',
  data() {
    const today = this.$moment().format('YYYY-MM-DD')
    const periodFormat = /[0-9]{4}-[0-9]{2}-[0-9]{2}/g
    return {
      tablePageOptions: [
        { value: 10, text: '10'},
        { value: 20, text: '20'},
        { value: 30, text: '30'},
        { value: 40, text: '40'},
        { value: 50, text: '50'}
      ],
      cards: {
        isLoaded: false,
        items: {
          contractFiducia: { img: "certificate.png", value: 0, text: "Kontrak Fiducia" },
          contractRoya: { img: "certificate.png", value: 0, text: "Kontrak Roya" },
          contractNonvalidated: { img: "certificate.png", value: 0, text: "Menunggu Validasi Dokumen" },
          contractValidated: { img: "certificate.png", value: 0, text: "Sudah Validasi Dokumen" },
          fiduciaUnpaid: { img: "waiting.png", value: 0, text: "Fiducia Belum Lunas" },
          fiduciaPaid: { img: "guarantee.png", value: 0, text: "Fiducia Lunas" },
          royaUnpaid: { img: "waiting.png", value: 0, text: "Roya Belum Lunas" },
          royaPaid: { img: "guarantee.png", value: 0, text: "Roya Lunas" },
          contractFiduciaWFN: { img: "certificate.png", value: 0, text: "Kontrak Fiducia WFN" },
          contractFiduciaSTN: { img: "certificate.png", value: 0, text: "Kontrak Fiducia STN" },
          contractFiduciaWFA: { img: "certificate.png", value: 0, text: "Kontrak Fiducia WFA" },
          contractFiduciaRCE: { img: "certificate.png", value: 0, text: "Kontrak Fiducia RCE" },
          contractRoyaWFN: { img: "certificate.png", value: 0, text: "Kontrak Roya WFN" },
          contractRoyaSTN: { img: "certificate.png", value: 0, text: "Kontrak Roya STN" },
          contractRoyaWFA: { img: "certificate.png", value: 0, text: "Kontrak Roya WFA" },
          contractRoyaRCE: { img: "certificate.png", value: 0, text: "Kontrak Roya RCE" },
        }
      },
      periodFrom: this.$moment().subtract(1, 'months').format('YYYY-MM-DD'),
      periodTo: today,
      minPeriod: '',
      maxPeriod: today,
      maxPeriodFrom: today,
      contractPerNotaryTable: {
        isLoaded: false,
        fields: [
          {key: "notaryCode", label: 'ID Notaris', sortable: true},
          {key: "notaryName", label: 'Nama Notaris', sortable: true},
          {key: "officeName", label: 'Nama Office', sortable: true},
          {key: "contractSTN", label: 'Kontrak STN', sortable: true},
          {key: "contractWFA", label: 'Kontrak WFA', sortable: true},
          {key: "contractRCE", label: 'Kontrak RCE', sortable: true},
        ],
        items: [],

        sort: {
          by: null,
          desc: false
        },

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },
      contractPerNotaryTable2: {
        isLoaded: false,
        fields: [
          {key: "notaryCode", label: 'ID Notaris', sortable: true},
          {key: "notaryName", label: 'Nama Notaris', sortable: true},
          {key: "officeName", label: 'Nama Office', sortable: true},
          {key: "contractSTN", label: 'Kontrak STN', sortable: true},
          {key: "contractWFA", label: 'Kontrak WFA', sortable: true},
          {key: "contractRCE", label: 'Kontrak RCE', sortable: true},
        ],
        items: [],

        sort: {
          by: null,
          desc: false
        },

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },
      contractDueTable: {
        isLoaded: false,
        fields: [
          {key: "contractNo", label: 'No. Kontrak'},
          {key: "customerName", label: 'Nama Customer'},
          {key: "contractType", label: 'Tipe Kontrak'},
          {key: "documentStatus", label: 'Status Dokumen'},
          {key: "contractStatus", label: 'Status Kontrak'}
        ],
        items: []
      },
      contractDueTable2: {
        isLoaded: false,
        fields: [
          {key: "contractNo", label: 'No. Kontrak'},
          {key: "customerName", label: 'Nama Customer'},
          {key: "contractType", label: 'Tipe Kontrak'},
          {key: "documentStatus", label: 'Status Dokumen'},
          {key: "contractStatus", label: 'Status Kontrak'}
        ],
        items: []
      },
      invoiceDueTable: {
        isLoaded: false,
        fields: [
          {key: "invoiceNo", label: 'No. Invoice'},
          {key: "businessUnit", label: 'Business Unit'},
          {key: "applicationDate", label: 'Tanggal Pengajuan'},
          {key: "contractType", label: 'Tipe Kontrak'},
          {key: "totalPayment", label: 'Nominal Pembayaran'}
        ],
        items: []
      }
    }
  },
  methods: {
  
    onSortChanged(ctx) {
      this.contractPerNotaryTable.sort.by = ctx.sortBy
      this.contractPerNotaryTable.sort.desc = ctx.sortDesc
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['FIMS'])){
        this.getContractPerNotaryTableItems(this.contractPerNotaryTable.currentPage)
      }
    },

    onSortChanged2(ctx) {
      this.contractPerNotaryTable2.sort.by = ctx.sortBy
      this.contractPerNotaryTable2.sort.desc = ctx.sortDesc
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['FIMS'])){
        this.getContractPerNotaryTableItems2(this.contractPerNotaryTable2.currentPage)
      }
    },

    onLimitChange(newPerPage) {
      this.contractPerNotaryTable.perPage = newPerPage
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['FIMS'])){
        this.getContractPerNotaryTableItems()
      }
    },
  
    onPageChange(newPage) {
      console.log(newPage)
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['FIMS'])){
        this.getContractPerNotaryTableItems(newPage)
      }
    },

    onPageChange2(newPage) {
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['FIMS'])){
        this.getContractPerNotaryTableItems2(newPage)
      }
    },

    // update datepicker valid dates on change
    onContextDateFrom() {
      this.minPeriod = this.periodFrom
    },
    onContextDateTo() {
      this.maxPeriodFrom = this.periodTo
    },
    onDateRangeSelect() {
      this.getStatistics()
    },
    // load card statistics
    getStatistics() {
      // URL builder
      let getUrl = "/dashboard/getStatistics"
      // get content from date range
      let params = {
        dateFrom: this.periodFrom,
        dateTo: this.periodTo
      }
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['Notaris'])){
        this.cards.isLoaded = false
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            sessionStorage.setItem("filterDashboardPeriodFrom", this.periodFrom)
            sessionStorage.setItem("filterDashboardPeriodTo", this.periodTo)
            for(const [key, data] of Object.entries(response.data.data)){
              this.cards.items[key].value = data
            }
          }
          else{
            this.$helper.toastError(this, "Load Statistik Dasbor Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Statistik Dasbor Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Statistik Dasbor Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.cards.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    getContractPerNotaryTableItems(page = 1) {
      if(isNaN(page)) {
        this.contractPerNotaryTable.currentPage = 1
      }
      else {
        this.contractPerNotaryTable.currentPage = page
      }
      // URL builder
      let getUrl = "/dashboard/getContractFiduciaCountPerNotary"
      let params = this.$helper.getBasePagedQuery(this.contractPerNotaryTable.currentPage - 1, this.contractPerNotaryTable.perPage)

      if(this.contractPerNotaryTable.sort.by != null) {
        params = this.$helper.getBaseSortQuery(this.contractPerNotaryTable.sort, params)
      }

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['FIMS'])){
        this.contractPerNotaryTable.isLoaded = false
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.contractPerNotaryTable.items = response.data.data.data.map(item => {
              return {
                notaryCode: item.notaryCode,
                notaryName: item.notaryName,
                officeName: item.officeName,
                contractSTN: item.contractSTN,
                contractWFA: item.contractWFA,
                contractRCE: item.contractRCE,
              }
            })
          this.contractPerNotaryTable.totalRows = response.data.data.totalElements
          this.contractPerNotaryTable.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kontrak Per Notaris Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Kontrak Per Notaris Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kontrak Per Notaris Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.contractPerNotaryTable.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    getContractPerNotaryTableItems2(page = 1) {
      if(isNaN(page)) {
        this.contractPerNotaryTable2.currentPage = 1
      }
      else {
        this.contractPerNotaryTable2.currentPage = page
      }
      // URL builder
      let getUrl = "/dashboard/getContractRoyaCountPerNotary"
      let params = this.$helper.getBasePagedQuery(this.contractPerNotaryTable2.currentPage - 1, this.contractPerNotaryTable2.perPage)

      if(this.contractPerNotaryTable2.sort.by != null) {
        params = this.$helper.getBaseSortQuery(this.contractPerNotaryTable2.sort, params)
      }

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['FIMS'])){
        this.contractPerNotaryTable2.isLoaded = false
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.contractPerNotaryTable2.items = response.data.data.data.map(item => {
              return {
                notaryCode: item.notaryCode,
                notaryName: item.notaryName,
                officeName: item.officeName,
                contractSTN: item.contractSTN,
                contractWFA: item.contractWFA,
                contractRCE: item.contractRCE,
              }
            })
          this.contractPerNotaryTable2.totalRows = response.data.data.totalElements
          this.contractPerNotaryTable2.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kontrak Per Notaris Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Kontrak Per Notaris Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kontrak Per Notaris Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.contractPerNotaryTable2.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    getContractDueTableItems() {
      // URL builder
      let getUrl = "/dashboard/getContractFiduciaNearDueDate"
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Notaris'])){
        this.contractDueTable.isLoaded = false
        this.$axios.get(getUrl).then(response => {
          if(response.status == 200){
            this.contractDueTable.items = response.data.data.data.map(item => {
              return {
                contractNo: item.contractNo,
                contractStatus: item.contractStatus,
                contractType: item.contractType,
                customerName: item.customerName,
                documentStatus: item.documentStatus
              }
            })
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kontrak Jatuh Tempo Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Kontrak Jatuh Tempo Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kontrak Jatuh Tempo Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.contractDueTable.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    getContractDueTableItems2() {
      // URL builder
      let getUrl = "/dashboard/getContractRoyaNearDueDate"
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Notaris'])){
        this.contractDueTable2.isLoaded = false
        this.$axios.get(getUrl).then(response => {
          if(response.status == 200){
            this.contractDueTable2.items = response.data.data.data.map(item => {
              return {
                contractNo: item.contractNo,
                contractStatus: item.contractStatus,
                contractType: item.contractType,
                customerName: item.customerName,
                documentStatus: item.documentStatus
              }
            })
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kontrak Jatuh Tempo Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Kontrak Jatuh Tempo Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kontrak Jatuh Tempo Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.contractDueTable2.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    // get 5 summary items for dashboard table
    getInvoiceDueTableItems() {
      // URL builder
      let getUrl = "/dashboard/getInvoiceNearDueDate"
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Notaris'])){
        this.invoiceDueTable.isLoaded = false
        this.$axios.get(getUrl).then(response => {
          if(response.status == 200){
            this.invoiceDueTable.items = response.data.data.data.map(item => {
              return {
                invoiceNo: item.invoiceNo,
                businessUnit: item.businessUnit,
                applicationDate: item.applicationDate,
                contractType: item.contractType,
                totalPayment: item.totalPayment
              }
            })
          }
          else{
            this.$helper.toastError(this, "Load Daftar Invoice Jatuh Tempo Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Invoice Jatuh Tempo Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Invoice Jatuh Tempo Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.invoiceDueTable.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    }
  },
  computed: {
  },
  mounted() {
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterDashboardPeriodFrom"))){
      this.periodFrom = sessionStorage.getItem("filterDashboardPeriodFrom")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterDashboardPeriodTo"))){
      this.periodTo = sessionStorage.getItem("filterDashboardPeriodTo")
    }
    this.getStatistics()
    if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['FIMS'])) {
      this.getContractPerNotaryTableItems()
      this.getContractPerNotaryTableItems2()
    }
    if(this.$helper.isRole(this.$availRoles['Notaris'])) {
      this.getContractDueTableItems()
      this.getContractDueTableItems2()
    }
    if(this.$helper.isRole(this.$availRoles['Notaris'])) this.getInvoiceDueTableItems()
  },
  created(){
    
  }
}
</script>

<style>

</style>
